<template>
    <div id="app" @touchstart="checkGlobalFn">
        <transition v-if="showRouter" :name="viewTransition" :css="!!direction">
            <router-view class="router-view"></router-view>
        </transition>
        <div v-else class="home-loading">
            <loading type="spinner" size="30px" color="#1989fa">加载中...{{error_msg}}</loading>
        </div>

        <wy-float v-if="showRouter && showQuickFace"></wy-float>
    </div>
</template>

<script>
  import {loading} from "vant";
  import {mapState} from "vuex";
  import WyFloat from "@/components/WyFloat";

  export default {
    name: "app",
    components: {loading, WyFloat},
    computed: {
      ...mapState({
        route: state => state.route,
        direction: state => state.direction,
        isLoading: state => state.isLoading,
        viewport: state => state.viewport,
        sign: state => state.sign,
        login_state: state => state.login_state,
        queueState: state => state.queueState,
        showQuickFace: false,
        user_id: state => state.user_id,
        user_name: state => state.user_name,
        websocket: state => state.websocket,
        websocket_send_data: state => state.websocket_send_data,
        invitation_apply_id: state => state.invitation_apply_id,
        wait_invitation_apply_id: state => state.wait_invitation_apply_id,
        seeker_openid: state => state.seeker_openid,
        refusedFace: state => state.refusedFace,
        queueObj: state => state.queueObj
      }),
      viewTransition() {
        if (!this.direction) return "";
        return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
      }
    },
    data() {
      return {
        showRouter: false,
        error_msg: "",
        cacheInvitation: [],
        queueInvitation: [],
        notifiedInvitation: {},
        queueNotify: [],
        timer: {
          notify: null,
          getNotify: null
        },
        enterHall: false,
        initWebscoket: false,
        timerWebscoket: null,
        timesWebsocket: 500,
        maxWebsocket: 100,

        wait_interview: {
          timer: null
        },
        webscoket_send: {
          timer: null,
          times: 3,
          queue: []
        }
      };
    },
    created() {
      window.onresize = () => {
        this.windowChange();
      };
      this.init();
    },
    mounted() {
    },
    methods: {
      windowChange() {
        const {viewport} = this;

        const current_width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

        if (viewport.width != current_width) {
          this.$dialog
            .alert({
              title: "窗口改变...!",
              message: "即将刷新页面...！"
            })
            .then(() => {
              const url = location.href;
              location.href = url;
            });
        }
      },
      checkDev() {
        this.$wechat.miniProgram.getEnv(res => {
          if (res && res.miniprogram) {
            this.init();
          } else {
            this.$dialog
              .alert({
                message: "环境错误,请在快招聘小程序中打开"
              })
              .then(() => {
                this.$wechat.closeWindow();
              });
          }
        });
      },
      init() {
        this.renderShow();
        /*const current_url = sessionStorage.getItem("current_url");
        if (this.$util.getQueryString("refresh_time") && current_url) {
          if (current_url.indexOf("refresh_time") >= 0) {
            sessionStorage.removeItem("current_url");
          }
          history.go(-1);
          // location.href = current_url;
          return;
        }
        const sign =
          this.$util.getQueryString("sign") || sessionStorage.getItem("sign");
        if (sign) {
          this.$store.commit("updateSign", { sign });
          this.renderShow(sign);
        } else {
          // 去登录
          this.goToLogin();
        }*/
      },
      renderShow() {
        let that = this;
        that.showRouter = true;
        /*
              that.$store.dispatch("getMyApply", { sign }).then(res => {
                const { code } = res;

                if (code === 1) {
                  if (that.checkOpenid()) {
                    that.showRouter = true;
                    that.getNotifyInvitation();

                    that.initWebSocket();
                  } else {
                    this.$util.getOpenId();
                  }
                } else {
                  that.goToLogin();
                }
              });*/
      },
      checkOpenid() {
        const {seeker_openid} = this;

        const url_openid = this.$util.getQueryString("openid");

        if (seeker_openid || url_openid) {
          if (!seeker_openid) {
            this.$store.commit("update_openid", url_openid);
            // 保存用户的openid
            this.saveOpenid(url_openid);
          }
          return true;
        } else {
          return false;
        }
      },
      saveOpenid(openid) {
        let that = this;
        const {sign} = this;
        return new Promise(resolve => {
          that.$util
            .get("kzp_video_jobfair", "kzp_openid_save", {openid, sign})
            .then(res => {
              // const { code } = res;
              // if (code == 1) {

              // }

              resolve(res);
            });
        });
      },
      goToLogin() {
        let that = this;
        that.$util
          .goToWxProgram("/pages/seeker/jobfair/main?need_login=1", "reLaunch")
          .then((state, res) => {
            if (state === "fail") {
              const {errMsg} = res || {};

              this.$dialog
                .alert({
                  title: "请在快招聘小程序中打开, 需要登录",
                  message: errMsg || ""
                })
                .then(() => {
                  this.$wechat.closeWindow();
                });
            }
          });
      },
      goToRtcRoom(invitation_apply_id) {
        let that = this;

        // 发送忙碌消息
        that.sendStateFn(invitation_apply_id, 1);

        that.$util
          .goToWxProgram(
            "/pages/common/webrtc-room/main?invitation_apply_id=" +
            invitation_apply_id,
            "navigateTo"
          )
          .then((state, res) => {
            if (state === "fail") {
              // 发送空闲
              that.sendStateFn(invitation_apply_id, 0);

              const {errMsg} = res || {};

              this.$dialog
                .alert({
                  title: "请在快招聘小程序中打开,面试",
                  message: errMsg || ""
                })
                .then(() => {
                });
            }
          });
      },
      // check_invitation： 面试和企业邀约的动态
      check_invitation() {
        let that = this;

        const {sign} = this;

        const params = {
          sign
        };

        return new Promise(resolve => {
          that.$util
            .get("kzp_video_jobfair", "check_invitation", params)
            .then(res => {
              const {code, data} = res;
              if (code === 1) {
                const {items} = data;
                if (items && items.length > 0) {
                  that.$set(that, "queueInvitation", [
                    ...that.queueInvitation,
                    ...items
                  ]);
                  that.getNotifyInvitation();
                }
              }

              resolve(res);
            });
        });
      },
      addQueueNotify(message) {
        let that = this;
        that.queueNotify.push(message);
        if (!that.timer.notify) {
          that.notifyInvitation();
        }
      },
      // 弹窗去处理企业的邀约
      notifyInvitation() {
        let that = this;

        const data = that.queueNotify[0];
        if (data && data.message) {
          that.timer.notify = true;

          const {item, message, type_name} = data;

          let duration = type_name === "企业邀约" ? 10000 : 5000;

          const {state, video_jobfair_id} = item || {};

          if (type_name === "企业邀约" && parseInt(state) === 0) {
            // 通知邀请列表刷新页面
            this.$store.commit("updateRefreshHome", {key: "wait", val: true});
          }

          that.$notify({
            duration,
            message,
            type: "success",
            onClick: () => {
              if (!video_jobfair_id) {
                return;
              }
              // 保存 当前信息属于哪一场双选会
              that.$store.commit("update_change_jobfair", {
                video_jobfair_id
              });

              sessionStorage.setItem("current_type", "wait");

              const path = "/sub/my_jobfair";
              if (that.route.path != path) {
                try {
                  that.$router.push({path});
                } catch (error) {
                  //
                }
              }
              that.$notify.clear();
            },
            onOpened: () => {
            },
            onClose: () => {
              that.timer.notify = false;

              that.queueNotify.shift();

              if (that.queueNotify.length > 0) {
                that.notifyInvitation();
              }
            }
          });
        }
      },
      getNotifyInvitation() {
        let that = this;

        const {notifiedInvitation, queueState} = that;

        const queueInvitation = JSON.parse(JSON.stringify(that.queueInvitation));

        if (queueInvitation.length > 0) {
          queueInvitation.forEach(item => {
            const invitation_apply_id = item.invitation_apply_id;

            if (notifiedInvitation[invitation_apply_id]) {
              that.queueInvitation.shift();
              return false;
            }

            const {company_name, state, type} = item;

            let message, type_name;
            const state_name = queueState[parseInt(state) + "-" + type];
            if (parseInt(type) === 0) {
              message = "您" + state_name + company_name + "的面试邀约";

              type_name = "企业邀约";
            } else {
              message = "您申请的" + company_name + "面试" + state_name;

              type_name = "面试申请";
            }

            that.queueNotify.push({message, item, type_name});
            that.notifiedInvitation[invitation_apply_id] = item;
            that.queueInvitation.shift();
          });

          if (!that.timer.notify) {
            that.notifyInvitation();
          }
        } else {
          that.check_invitation();
        }
      },
      initWebSocket() {
        var wsServer = "wss://m-kzp.bysjy.com.cn/invitation_socket";
        if (!WebSocket) {
          alert("您的浏览器不支持WebSocket, 请升级更新!");
          return;
        }

        let {errorNum, websocket, user_id} = this;

        if (errorNum <= 0) {
          alert("WebSocket连接超时, 请刷新再试!");
          return;
        }

        let that = this;
        let heartCheck = {
          timeout: 30 * 1000,
          timeoutObj: null,
          serverTimeoutObj: null,
          reconnectTimeout: 3000,
          lockReconnect: false,
          reset: function () {
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            this.start();
          },
          start: function () {
            // console.log("start websocket");
            let self = this;
            this.timeoutObj = setTimeout(function () {
              // 保持心跳
              websocket.send("HeartBeat");
              self.serverTimeoutObj = setTimeout(function () {
                websocket.close();
              }, self.timeout);
            }, this.timeout);
          }
        };
        if (
          !(websocket && websocket.readyState === 1) &&
          that.initWebscoket === false
        ) {
          that.initWebscoket = true;
          if (websocket) {
            websocket.close();
          }
          websocket = new WebSocket(wsServer);

          that.$store.commit("updateWebsocket", websocket);

          websocket.onopen = function (evt) {
            console.log("onopen", evt);
            // 初始化
            var msg = {
              flag: "init",
              sender_uid: user_id,
              msg_from: "user",
              group_id: ""
            };
            var msg_str = JSON.stringify(msg);
            that.websocket.send(msg_str);

            heartCheck.start();

            // 设置websocket 为可以发送
          };
          websocket.onclose = function (evt) {
            console.log("onclose", evt);
            // that.initWebSocket();
          };
          websocket.onerror = function (evt, e) {
            console.log("onerror", evt, e);
            that.reconnect();
          };

          websocket.onmessage = function (e) {
            if (e.data === "PongPong") {
              heartCheck.reset();
              return false;
            } else {
              try {
                var websocketData = JSON.parse(e.data) || [];
                if (that.$util.isArrayFn(websocketData)) {
                  that.$store.commit("updateCompanyOnline", {
                    list: websocketData
                  });
                } else if (websocketData && websocketData.flag) {
                  that.websocketflag(websocketData);
                }
              } catch (error) {
                //
              }
            }
            //重置心跳
            heartCheck.reset();
          };

          that.initWebscoket = false;
        }

        return websocket;
      },
      websocketSend(poll) {
        let that = this;

        if (poll) {
          --that.webscoket_send.times;
        } else {
          that.webscoket_send.times = 3;
        }

        const data = that.webscoket_send.queue[0];

        if (!data) {
          return;
        }

        let {websocket, user_id} = this;
        if (websocket && websocket.readyState === 1) {
          try {
            let send_msg = data;
            if (typeof data === "string") {
              send_msg = data;
            } else {
              if (!send_msg["sender_uid"]) {
                send_msg["sender_uid"] = user_id;
              }

              if (!send_msg["msg_from"]) {
                send_msg["msg_from"] = "user";
              }

              if (!send_msg["msg_to"]) {
                send_msg["msg_to"] = "company";
              }

              if (!send_msg["time"]) {
                send_msg["time"] = new Date().getTime();
              }
              send_msg = JSON.stringify(send_msg);
            }
            websocket.send(send_msg);

            that.webscoket_send.queue.shift();
          } catch (error) {
            //
          }
        } else {
          this.reconnect();
          // 发送不成功、然后最多访问次数  webscoket_send.times
          if (that.webscoket_send.times < 0) {
            that.webscoket_send.times = 3;
            return;
          }

          clearTimeout(that.webscoket_send.timer);
          that.webscoket_send.timer = setTimeout(() => {
            that.websocketSend(true);
          }, 3000);
        }
      },
      websocketflag(data) {
        const {
          flag,
          sender_uid,
          receiver_uid,
          business_type,
          group_id,
          business_id,
          business_txt
        } = data; // ,

        let that = this;

        const {user_id} = that;

        switch (flag) {
          case "notice":
            // 私人消息
            if (parseInt(user_id) !== parseInt(receiver_uid)) {
              return;
            }
            // 企业邀约、求职者申请面试、企业发起面试、求职者发起面试、企业处理求职者发起的面试
            switch (business_type) {
              case "面试":
                that.dealFlagNotice(parseInt(business_txt), business_id);
                break;
              case "处理面试":
                that.dealInterviewFn(business_id, business_txt);
                break;
              case "邀约":
                that.dealErpInvitation(group_id, business_id, business_txt);
                break;
              case "处理邀约":
                that.dealApplyNotify(
                  sender_uid,
                  group_id,
                  business_id,
                  business_txt
                );
                break;
              case "取消":
                that.cancelApplyNotify(
                  sender_uid,
                  group_id,
                  business_id,
                  business_txt
                );
                break;
              default:
                break;
            }
            break;
          case "all":
            //全局广播

            break;
          default:
            break;
        }
      },
      dealFlagNotice(interview_state_int, invitation_apply_id) {
        const {wait_invitation_apply_id} = this;
        const last_invitation_apply_id = parseInt(this.invitation_apply_id);

        if (interview_state_int !== 1) {
          // 处理企业结束2、挂断0
          // 通知面试界面、加载界面
          if (
            parseInt(invitation_apply_id) === last_invitation_apply_id ||
            last_invitation_apply_id == 0
          ) {
            this.$store.commit("update_invitation_apply_id", -5);
          }
          return;
        }

        // 求职者正在面试中
        if (last_invitation_apply_id > 0) {
          return;
        }

        const refusedData = this.refusedFace[invitation_apply_id];
        if (refusedData) {
          const nowTimestamp = new Date().getTime();
          // 拒绝过的面试在11秒内再接收到webscoket的通知忽略
          if (refusedData.timestamp + 11 * 1000 > nowTimestamp) {
            return;
          }
        }

        // 求职者正在等待企业接受面试
        if (wait_invitation_apply_id > 0) {
          return;
        }

        if (interview_state_int === 1 && last_invitation_apply_id <= 0) {
          const path = "/interview";
          const path_url =
            "/interview?notify=1&invitation_apply_id=" + invitation_apply_id;
          if (this.route.path == path || location.href.indexOf(path) > 0) {
            if (!this.$util.getQueryString("notify")) {
              location.href = path_url;
            }
          } else {
            this.$router.push({
              path: path_url
            });
          }
        }
      },
      dealInterviewFn(business_id, business_txt) {
        let that = this;
        const {wait_invitation_apply_id} = this;

        if (wait_invitation_apply_id !== parseInt(business_id)) {
          return;
        }

        that.endInterview().then(() => {
          if (business_txt && parseInt(business_txt) > 0) {
            // 接受
            that.$store.commit(
              "update_invitation_apply_id",
              wait_invitation_apply_id
            );
          } else {
            // 拒绝
            that.$dialog.alert({
              title: "发起面试未成功",
              message: "企业拒绝了你的面试请求!"
            });
          }
        });
      },
      dealErpInvitation(group_id, business_id, business_txt) {
        let that = this;
        that.addQueueNotify({
          message: business_txt,
          item: {
            state: 0,
            video_jobfair_id: group_id,
            invitation_apply_id: business_id || 0
          },
          type_name: "企业邀约"
        });
      },
      dealApplyNotify(sender_uid, group_id, business_id, business_txt) {
        let that = this;
        // 处理申请通知
        const state = business_txt.indexOf("【同意】") >= 0 ? 1 : 2;

        that.addQueueNotify({
          message: business_txt,
          item: {
            state,
            video_jobfair_id: group_id,
            invitation_apply_id: business_id
          },
          type_name: "处理邀约"
        });

        // 更新申请排队记录
        let queueObj = that.queueObj;
        queueObj[sender_uid] = {
          invitation_apply_id: business_id,
          state,
          type: 1
        };

        that.$store.commit("update_single_state", {
          key: "queueObj",
          data: queueObj
        });

        that.$forceUpdate();
      },
      cancelApplyNotify(sender_uid, group_id, business_id, business_txt) {
        // 取消面试排队
        let that = this;
        if (business_txt) {
          that.addQueueNotify({
            message: business_txt,
            item: {
              video_jobfair_id: group_id,
              invitation_apply_id: business_id
            },
            type_name: "取消排队"
          });
        }

        // 更新申请排队记录
        let queueObj = that.queueObj;
        if (queueObj[sender_uid]) {
          queueObj[sender_uid] = undefined
        }
        that.$store.commit("update_single_state", {
          key: "queueObj",
          data: queueObj
        });

        that.$forceUpdate();
      },
      reconnect() {
        // 重新初始化webscoket
        let that = this;
        clearTimeout(that.timerWebscoket);
        if (that.maxWebsocket < 0) {
          this.$dialog
            .alert({
              title: "webscoket服务连接超时!",
              message: "点击确定按钮重连"
            })
            .then(() => {
              const url = location.href;
              location.href = url;
            });
          return;
        }
        that.timerWebscoket = setTimeout(() => {
          that.maxWebsocket--;
          that.initWebSocket();
        }, that.timesWebsocket);
      },
      checkGlobalFn() {
        // 保持websocket 刷新
        const {websocket, invitation_apply_id} = this;

        if (!websocket || (websocket && websocket.readyState !== 1)) {
          this.reconnect();
        }

        // 保持可以接受面试, 当从面试返回的时候，用户点击即可重新触发，是的用户能够接受面试的webscoket通知
        if (invitation_apply_id > 0) {
          this.$store.commit("update_invitation_apply_id", 0);
        }
      },
      waitInterviewFn() {
        let that = this;

        // 弹出加载窗
        that.$toast.loading({
          duration: 0,
          message: "等待企业确定...",
          forbidClick: true
        });

        clearTimeout(that.wait_interview.timer);
        that.wait_interview.timer = setTimeout(() => {
          that.endInterview().then(() => {
            // 提示超时
            that.$dialog.alert({
              title: "连接超时，企业未响应",
              message: "请稍后再向企业发起面试"
            });
          });
        }, 45000);
      },
      endInterview() {
        let that = this;
        return new Promise(resolve => {
          clearTimeout(that.wait_interview.timer);
          that.$store.commit("update_wait_invitation_apply_id", 0);
          that.$toast.clear();

          resolve();
        });
      },
      sendStateFn(invitation_apply_id, param) {
        if (!invitation_apply_id) {
          return;
        }
        this.$store.commit("update_single_state", {
          key: "websocket_send_data",
          data: {
            flag: "state",
            msg_from: "user",
            receiver_uid: "",
            business_type: "状态",
            business_id: invitation_apply_id,
            business_txt: param ? 1 : 0
          }
        });
      }
    },
    watch: {
      login_state: {
        handler(val, oldVal) {
          if (val > oldVal) {
            this.goToLogin();
          }
        },
        deep: true
      },
      invitation_apply_id: {
        handler(val, oldVal) {
          if (val > 0 && val != oldVal) {
            this.goToRtcRoom(val);
          }
        },
        deep: true
      },
      "route.path": {
        handler(val, oldVal) {
          if (this.showRouter && val && val != oldVal) {
            sessionStorage.setItem("current_url", location.href);
          }
        }
      },
      wait_invitation_apply_id: {
        handler(val, oldVal) {
          if (val > 0 && val != oldVal) {
            this.waitInterviewFn();
          }
        },
        deep: true
      },
      websocket_send_data: {
        handler(val, oldVal) {
          if (val && val != oldVal) {
            this.webscoket_send.queue.push(val);
            this.websocketSend();
          }
        },
        deep: true
      }
    }
  };
</script>

<style lang="scss" scoped>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        margin: 0px;
        height: 100%;
        width: 100%;

        .router-view {
            width: 100%;
            height: 100%;
            overflow-x: hidden;
            @include box-sizing(border-box);
        }

        .home-loading {
            padding: 1rem 0;
        }
    }

    .vux-popup-mask.vux-popup-show {
        z-index: 1 !important;
    }

    .vux-pop-out-enter-active,
    .vux-pop-out-leave-active,
    .vux-pop-in-enter-active,
    .vux-pop-in-leave-active {
        will-change: transform;
        transition: all 500ms;
        height: 100%;
        position: absolute;
        backface-visibility: hidden;
        perspective: 1000;
    }

    .vux-pop-out-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    .vux-pop-out-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .vux-pop-in-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .vux-pop-in-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
</style>
